import { GetTaskInfoData, GetTaskListData, UpdateTaskListData } from "../../interfaces/store/actions/payload/task";
import { GetTaskInfoAction, GetTaskListAction, UpdateTaskListAction } from "../../interfaces/store/actions/task";
import { GET_TASK_INFO, GET_TASK_LIST, UPDATE_TASK_LIST } from "./availableActions";

export const getTaskList = (payload?: GetTaskListData): GetTaskListAction => ({
    type: GET_TASK_LIST,
    payload,
});

export const updateTaskList = (payload: UpdateTaskListData): UpdateTaskListAction => ({
    type: UPDATE_TASK_LIST,
    payload,
});

export const getTaskInfo = (payload: GetTaskInfoData): GetTaskInfoAction => ({
    type: GET_TASK_INFO,
    payload,
});
